import React from "react";

const ActiveFilters = ({
                           searchTerm,
                           setSearchTerm,
                           selectedServices = [],
                           setSelectedServices,
                           selectedSpecialities = [],
                           setSelectedSpecialities,
                           selectedDepartments = [],
                           setSelectedDepartments,
                           selectedLanguages = [],
                           setSelectedLanguages,
                           selectedHours = [],
                           setSelectedHours,
                           selectedInsurance = [],
                           setSelectedInsurance,
                           selectedMedicaid = [],
                           setSelectedMedicaid,
                           selectedAccessibility = [],
                           setSelectedAccessibility,
                           selectedAwards,
                           setSelectedAwards,
                           selectedQualityAndAccreditation,
                           setSelectedQualityAndAccreditation,
                           selectedRating,
                           setSelectedRating,
                           location,
                           setLocation,
                           distance,
                           setDistance,
                            
                       }) => {
    const filters = [];

    // Añadir chip de búsqueda si existe searchTerm
    if (searchTerm && searchTerm.trim()) {
        filters.push({ 
            label: `Search: "${searchTerm}"`, 
            onClear: () => setSearchTerm("") 
        });
    }

    if (selectedServices.length)
        filters.push({ label: `Services: ${selectedServices.join(", ")}`, onClear: () => setSelectedServices([]) });
    if (selectedSpecialities.length)
        filters.push({ label: `Specialities: ${selectedSpecialities.join(", ")}`, onClear: () => setSelectedSpecialities([]) });
    if (selectedDepartments.length)
        filters.push({ label: `Departments: ${selectedDepartments.join(", ")}`, onClear: () => setSelectedDepartments([]) });
    if (selectedLanguages.length)
        filters.push({ label: `Languages: ${selectedLanguages.join(", ")}`, onClear: () => setSelectedLanguages([]) });
    if (selectedHours.length)
        filters.push({ label: `Hours: ${selectedHours.join(", ")}`, onClear: () => setSelectedHours([]) });
    if (selectedInsurance.length)
        filters.push({ label: `Insurance: ${selectedInsurance.join(", ")}`, onClear: () => setSelectedInsurance([]) });
    if (selectedMedicaid.length)
        filters.push({ label: `Medicaid: ${selectedMedicaid.join(", ")}`, onClear: () => setSelectedMedicaid([]) });
    if (selectedAccessibility.length)
        filters.push({ label: `Accessibility: ${selectedAccessibility.join(", ")}`, onClear: () => setSelectedAccessibility([]) });
    if (selectedAwards && selectedAwards !== "Any")
        filters.push({ label: `Awards: ${selectedAwards}`, onClear: () => setSelectedAwards("Any") });
    if (selectedQualityAndAccreditation && selectedQualityAndAccreditation !== "Any")
        filters.push({ label: `Accreditation: ${selectedQualityAndAccreditation}`, onClear: () => setSelectedQualityAndAccreditation("Any") });
    if (selectedRating)
        filters.push({ label: `Rating: ${selectedRating} & up`, onClear: () => setSelectedRating(null) });
    if (location)
        filters.push({ label: `Location: ${location}`, onClear: () => setLocation("") });
    if (distance !== null && distance !== 0)
        filters.push({ label: `Distance: ${distance} mi`, onClear: () => setDistance(0) });

    const clearAllFilters = () => {
        setSearchTerm("");
        setSelectedServices([]);
        setSelectedSpecialities([]);
        setSelectedDepartments([]);
        setSelectedLanguages([]);
        setSelectedHours([]);
        setSelectedInsurance([]);
        setSelectedMedicaid([]);
        setSelectedAccessibility([]);
        setSelectedAwards("Any");
        setSelectedQualityAndAccreditation("Any");
        setSelectedRating(null);
        setLocation("");
        setDistance(0);
    };

    return (
        filters.length > 0 && (
            <div className="my-2 d-flex justify-content-between align-items-center">
                <div className="d-flex gap-3 align-items-center">
                    <p className="small fw-semibold text-muted mb-2 mt-2">Active Filters:</p>
                    <div className="d-flex flex-wrap gap-2">
                        {filters.map(({ label, onClear }, index) => (
                            <div key={index} className="badge bg-white border rounded-pill px-3 py-2 d-flex align-items-center">
                                <span className="text-muted small me-2">{label}</span>
                                <button className="btn-close btn-sm p-0" onClick={onClear} />
                            </div>
                        ))}
                    </div>
                </div>
                <button 
                    className="btn btn-link p-0 text-primary small text-decoration-none"
                    onClick={clearAllFilters}
                >
                    Clear All
                </button>
            </div>
        )
    );
};

export default ActiveFilters;